import { dayjs } from '@karve.it/core';

import { PotentialCrewMember } from './store/dispatch.reducer';

export const generateCrewCsv = (
    crew: PotentialCrewMember[],
    zoneName: string,
    date: Date,
    currentTimezone: string,
    separator = ','
): { blob: Blob, filename: string } => {
    const csvHeader = [
        "Given Name", "Family Name", "Email", "Phone", "Hourly Rate", "Capabilities", "Available",
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
        "Timezone", "Max Hours Per Day", "Max Hours Per Week", "Pay Period Start", "Overtime Rate",
        "Estimated Working Time", "Hours Worked", "Overtime Hours"
    ].join(separator) + '\n';

    const csvRows = crew.map(c => {
        const capabilities = (c.user?.capabilities || [])?.join(';');
        const availability = [...(c.user.availability || [])];
        while (availability.length < 7) {
            availability.push('');
        }

        const row = [
            c.user.givenName,
            c.user.familyName,
            c.user.email,
            c.user.phone,
            (c.user.rateHourly || 0) / 100,
            `"${capabilities}"`,
            c.user.available || 'FALSE',
            ...availability.slice(0, 7).map(a => {
                if (a && a.startsWith('Y')) {
                    return `"${a.substring(1)}"`;
                }
                if (a && a.startsWith('N')) {
                    return '""';
                }
                return `"${a}"`;
            }),
            c.user.timezone || currentTimezone,
            c.user.maxHoursPerDay || 24,
            c.user.maxHoursPerWeek || 40,
            c.user.payPeriodStart || 0,
            c.user.overtimeRate || 1.5,
            `"${c.estWorkingTime || ''}"`,
            c.hoursWorked || 0,
            c.overtimeHours || 0,
        ];
        return row.join(separator);
    }).join('\n');

    const csvContent = csvHeader + csvRows;
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const dateString = dayjs(date).format('YYYY-MM-DD');
    const filename = `${zoneName}-crew-${dateString}.csv`;

    return { blob, filename };
};
